import script from "./VolunteeringCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteeringCalendar.vue?vue&type=script&setup=true&lang=js"

import "./VolunteeringCalendar.vue?vue&type=style&index=0&id=388bbf10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388bbf10"]])

export default __exports__